import qs from 'qs';
import { network } from 'services/network';

export const setBaseLineDateOption = ({ projectId, option }) => {
    const querystring = qs.stringify({ projectId, option }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setBaseLineDateOption${querystring}`;
    return network.post(url).then((response) => response.data);
};
